<template>
	<div class="main-container">
		<SiderLayer />
		<div class="dashboard">
			<div class="dashboard__area">
				<div class="dashboard-info">
					<div class="info__content">
						<div class="panel">
							<div class="row">
								<div class="col-9">
									<h2>
										안녕하세요 :) {{ gStore?.userInfo?.studentName }}학생
										<!-- 👋 -->
										<q-icon name="img:/assets/images/icon/img_main_hello.png" />
									</h2>
									<p>오늘의 학습을 진행해 주세요.</p>
								</div>
								<p class="col-3">
									<img
										src="@/assets/images/icon/img_main_kreadbook01_green.png"
										fit="scale-down"
									/>
								</p>
							</div>
						</div>
					</div>
				</div>

				<!-- 아래는 실제 사용하는 영역 -->
				<!-- ------------------------------------------------------------------------------------------------------------  -->
				<div class="dashboard__content">
					<div class="learning-process">
						<h3>오늘의 학습</h3>
						<q-card v-if="areaCodeArr" flat>
							<template
								v-for="(k, idx) in Object.values(areaCodeArr)"
								:key="idx"
							>
								<div
									class="panel literature"
									v-if="
										k.length > 0 &&
										k[0].learningType !== 'SAT' &&
										k[0].learningType !== 'SAT_RESET'
									"
									:style="
										'height: calc( ' +
										100 / Object.values(areaCodeArr).length +
										'%  - 25px );'
									"
								>
									<div class="literature__content">
										<div class="row">
											<div class="chip">
												<q-chip
													:style="
														'background-color:' +
														learningType[k[0].learningType]?.color +
														';'
													"
												>
													<b>
														{{ learningType[k[0].learningType]?.label }}
													</b>
												</q-chip>
											</div>
											<p
												class="level"
												v-if="k[0].learningType !== 'SUGGESTION_DIAGNOSTIC'"
											>
												{{ k[0]?.level }}레벨
											</p>
											<p
												class="level"
												v-if="k[0].learningType === 'SUGGESTION_DIAGNOSTIC'"
											>
												진단
											</p>
											<p class="literature__type">
												지문1{{
													k[0]?.passageClass ? '-' + k[0].passageClass : ''
												}}
											</p>
											<div class="col">
												<p class="pass-name">
													{{ k[0].passageName }}
												</p>
												<div class="chip-outline">
													<q-chip
														v-if="
															k[0].learningStatus !== 'W' &&
															k[0].learningStatus !== 'S' &&
															k[0].learningStatus !== 'D'
														"
														outline
														:style="
															'color:' +
															(k[0].learningStatus === 'I'
																? '#4659FF;'
																: k[0].learningStatus === 'C'
																? '#8E8E8E;'
																: k[0].learningStatus === 'R'
																? '#EF2B2A'
																: '')
														"
													>
														<b> {{ learningStatus[k[0].learningStatus] }} </b>
													</q-chip>
												</div>
											</div>
										</div>
										<div class="row">
											<p class="literature__title">
												{{ k[0]?.areaCode === '02' ? '비' : '' }}문학
											</p>
											<p
												class="level"
												v-if="k[0].learningType !== 'SUGGESTION_DIAGNOSTIC'"
											>
												{{ k[0]?.lesson }}레슨
											</p>
											<p
												class="level"
												v-if="k[0].learningType === 'SUGGESTION_DIAGNOSTIC'"
											>
												추천-{{ k[0]?.groupIndex }}
											</p>
											<p v-if="k[1]" class="literature__type">
												지문2{{
													k[1]?.passageClass ? '-' + k[1]?.passageClass : ''
												}}
											</p>
											<div v-if="k[1]" class="col">
												<p class="pass-name">
													{{ k[1].passageName }}
												</p>
												<div class="chip-outline">
													<q-chip
														v-if="
															k[1].learningStatus !== 'W' &&
															k[1].learningStatus !== 'S' &&
															k[1].learningStatus !== 'D'
														"
														outline
														:style="
															'color:' +
															(k[1].learningStatus === 'I'
																? '#4659FF;'
																: k[1].learningStatus === 'C'
																? '#8E8E8E;'
																: k[1].learningStatus === 'R'
																? '#EF2B2A'
																: '')
														"
													>
														<b> {{ learningStatus[k[1].learningStatus] }} </b>
													</q-chip>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div
									class="panel sat"
									v-if="
										k.length > 0 &&
										(k[0].learningType === 'SAT' ||
											k[0].learningType === 'SAT_RESET')
									"
								>
									<div class="panel__inner">
										<div class="sat__content">
											<p class="sat__img">
												<img src="@/assets/images/icon/img_main_SAT.png" />
											</p>
											<div class="sat__txt">
												<p class="level">
													<span>{{ k[0]?.level }}레벨</span>
													<span>{{ k[0]?.satOrder }}회차</span>
													<q-chip
														v-if="k[0].learningType === 'SAT_RESET'"
														style="
															margin-left: 0.8vw;
															background-color: #e8dfff;
															color: #424242;
														"
													>
														<b>리셋</b>
													</q-chip>
												</p>
												<p class="panel__title">수능모의평가</p>
											</div>
										</div>
										<p class="panel__txt">
											수능모의평가를 통해 나의 예측등급을 알아보세요.
										</p>
									</div>
								</div>
							</template>
							<div
								class="panel diagnosis"
								v-if="areaCodeArr.length === 0 && !isAllCourseCompleted"
							>
								<div class="panel__inner">
									<div class="diagnosis__content">
										<p class="diagnosis__img">
											<img
												src="@/assets/images/icon/img_main_diagnosis_green.png"
											/>
										</p>
										<p class="diagnosis__kread">
											<img src="@/assets/images/main/kread.svg" />
										</p>
										<p class="panel__title">진단평가</p>
									</div>
									<p class="panel__txt">
										KReaD 진단평가에 응시해 주세요.<br />진단평가 후 학습을
										시작할 수 있어요.
									</p>
								</div>
							</div>
							<div
								class="panel diagnosis"
								v-if="areaCodeArr.length === 0 && isAllCourseCompleted"
							>
								<div class="panel__inner">
									<div class="diagnosis__content">
										<p class="diagnosis__img">
											<img
												src="@/assets/images/icon/img_main_diagnosis_green.png"
											/>
										</p>
										<p class="diagnosis__kread">
											<img src="@/assets/images/main/kread.svg" />
										</p>
										<p class="panel__title">진단평가</p>
									</div>
									<p class="panel__txt">
										모든 학습이 완료되었습니다.<br />진단평가를 통해 향상된
										실력을 확인해보세요.
									</p>
								</div>
							</div>

							<div class="button__content">
								<CusButton
									:type="210"
									:label="`학습하기`"
									@onReturn="studyStart"
								/>
							</div>
							<!-- <q-btn v-if="!isLoading" unelevated color="primary" @click="studyStart">
                                <span class="btn__txt">
                                    <span>학습하기</span>
                                    <q-icon name="arrow_forward_ios" />
                                </span>
                            </q-btn> -->
						</q-card>
					</div>
				</div>
				<!-- ------------------------------------------------------------------------------------------------------------  -->
			</div>
		</div>
		<div class="infobaord">
			<div class="infobaord__area">
				<div class="today-notification">
					<div class="notification__content">
						<h3>알림</h3>
						<div class="panel notice">
							<div class="notice__content">
								<!-- <q-icon name="campaign" size="30px" style="color: #d9d9d9" /> -->
								<q-icon name="img:/assets/images/icon/img_main_notice.png" />
								<p
									class="message"
									v-if="message"
									:onClick="
										() => {
											router.push('/inform');
										}
									"
								>
									<span class="message__type">{{ message?.type }}</span>
									<span class="message__title">
										{{ message?.title }}
										<!-- 내일은
                                      <span style="font-weight: 700;">
                                          추천학습이 예정
                                      </span>
                                      되어있습니다. -->
									</span>
								</p>
								<p class="message" v-if="!message" :onClick="gotoInform">
									<!-- <div style="color:#999;font-size: 20px; ">{{ moment().format('YYYY-MM-DD') }}</div> -->
									<!-- <span class="message__type">추천학습</span> -->
									<span class="message__title">
										{{ gStore?.userInfo?.academyName }}
										<span
											v-if="gStore?.userInfo?.academyPhone"
											class="text-bold"
											>({{ gStore?.userInfo?.academyPhone }})</span
										>
									</span>
								</p>
							</div>
						</div>
					</div>
				</div>

				<!-- 기존 서비스에서 쓸 영역 -->
				<!-- ------------------------------------------------------------------------------------------------------------  -->
				<div class="infobaord__content">
					<div class="now-learning">
						<div class="now-learning__header">
							<h3>지식맵</h3>
							<q-btn flat no-ripple @Click="gotoMap">
								<span class="more">더보기</span>
								<q-icon
									class="more__btn"
									name="img:/assets/images/icon/ico_next.svg"
								/>
							</q-btn>
						</div>
						<div class="panel now-learning__content" v-if="areaCodeArr">
							<div class="panel__inner" :onClick="gotoMap">
								<div
									class="during-learning"
									v-if="
										Object.values(areaCodeArr).length > 0 ||
										isAllCourseCompleted === true
									"
								>
									<div class="level">
										<p>레벨</p>
										<LevelChart
											v-if="studyStore?.level"
											:level="studyStore?.level"
											:max="3"
											height="2"
											class="level__graph"
											style="cursor: pointer"
										/>
										<!-- <LevelChart v-if="lev" :level="lev" :max="3" height="40" style="cursor: pointer" /> -->
									</div>
									<div class="lesson">
										<p>레슨</p>
										<lessonChart
											v-if="studyStore?.lesson"
											:lesson="studyStore?.lesson"
											height="3"
											class="lesson__graph"
											style="cursor: pointer"
										/>
										<!-- <lessonChart v-if="les" :lesson="les" :height="3.33" style="cursor: pointer" /> -->
									</div>
								</div>
								<div
									class="learning-beginning"
									v-if="
										Object.values(areaCodeArr).length === 0 &&
										isAllCourseCompleted === false
									"
								>
									<p class="learning__img">
										<img src="@/assets/images/icon/img_empty_archer.png" />
									</p>
									<p class="beginning__title">
										진단평가를 통해,<br />
										나의 학습 수준 및 위치를 확인해 보세요.
										<!-- KReaD진단평가를 통해<br />
                      나의 KReaD 지수를 확인하고<br />
                      독해 능력을 확인해 보세요. -->
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- ------------------------------------------------------------------------------------------------------------  -->
			</div>
		</div>
	</div>
</template>

<script setup>
import { DialogStore } from '@/store/modules/dialog';
import { StudyStore } from '@/store/modules/study';
import { GlobalStore } from '@/store';
import barChart from '@/components/chart/barChart.vue';
import { routerKey, useRouter, useRoute } from 'vue-router';
import { ref, onMounted, computed, watch } from 'vue';
import { useQuasar } from 'quasar';
import HOME_API from '@/api/modules/home';
import _ from 'lodash';
import {
	getUserJson,
	getUserInfo as getUserInfoApi,
	getUserMain,
	getMainMessage,
} from '@/api/modules/login';
import * as zzApi from '@/api/modules/login';
import { JsonData } from '@amcharts/amcharts5';
import {
	headerEtcCd01,
	headerEtcCd05,
	learningType,
	learningStatus,
} from '@/helpers/qbankParser/qbankMeta';
import moment, { now } from 'moment';
import SiderLayer from '@/components/layouts/sider/siderLayer.vue';
import lessonChart from '@/components/chart/lessonChart.vue';
import LevelChart from '@/components/chart/levelChart.vue';
import { getUserInfo } from '@/api/modules/mypage.js';
import { apiLogin4Member } from '@/api/modules/eval_api.js';

import CusButton from '@/components/widget/CusButton.vue';
import { monitoringLog } from '@/api/modules/monitoring';

import { checkProgress } from '@/api/modules/study';

const store = DialogStore();
const gStore = GlobalStore();
const studyStore = StudyStore();
const router = useRouter();
const route = useRoute();
const value = 0.2;
// const alert = ref(null);
// const isLoading = ref(true);
const isLoading = ref(true);
const message = ref(null);
const progress = 0.3;
const { getTodayLesson, getUserType } = HOME_API();

const todayLesson = ref({});
const userType = ref({});

const areaCodeArr = ref(null);
const studyData = ref(null);
const isAllCourseCompleted = ref(false);
const $q = useQuasar();

const lev = ref();
const les = ref();

// alert.value = false;

const openAlert = () => {
	// alert.value = true;
};

const openDialog = () => {
	store.openModal(true);
};

const logOut = () => {
	gStore.setToken(undefined);
	gStore.setReToken(undefined);
	studyStore.initStore();
	router.push('/login');
};

const gotoMap = () => {
	router.push('/map');
};
const gotoInform = () => {
	router.push('/inform');
};
const moveToPage = path => {
	// TODO: 테스트후 변경
	// router.push({ path })
	$q.dialog({
		title: '확인',
		message: '서비스 준비중입니다.',
		cancel: true,
		persistent: true,
	});
};

/* 5월 31일 용 start */
const tempRs = ref('noLevel');
/* 5월 31일 용 end */

/* KRT-1414 */
const setMessage = async () => {
	const res = await zzApi.getMainMessage2();
	if (res && res.status === 200) {
		const rs = res.data.data;
		if (rs.length) message.value = { type: rs[0].typeStr, title: rs[0].title };
	}
};
/* KRT-1414 */
const setUserMain = async () => {
	const res = await zzApi.getUserMain2();
	if (res && res.status === 200) {
		const rs = res.data.data;
		if (rs == 'noLevel') {
			tempRs.value = 'noLevel';
			// console.log("rs : " + rs + ", tempRs : " + tempRs.value);
		} else {
			let tmpMapTree = [];
			let tmpStudy = {};
			lev.value = rs.level;
			les.value = rs.lesson;
			if (rs.studyMain.length > 0) {
				rs.studyMain.forEach(element => {
					// let tmpItem = tmpStudy[element.areaCode + '_' + element.areaCode] === null ? [] : tmpStudy[element.areaCode + '_' + element.areaCode];
					if (tmpStudy[element.learningType + '_' + element.areaCode]) {
						if (
							tmpStudy[element.learningType + '_' + element.areaCode].length >=
							2
						) {
							if (tmpStudy[element.learningType + '_' + element.areaCode + 1])
								tmpStudy[
									element.learningType + '_' + element.areaCode + 1
								].push(element);
							else
								tmpStudy[element.learningType + '_' + element.areaCode + 1] = [
									element,
								];
						} else {
							tmpStudy[element.learningType + '_' + element.areaCode].push(
								element
							);
						}
					} else {
						tmpStudy[element.learningType + '_' + element.areaCode] = [element];
					}
					tmpMapTree.push({
						// examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
						examCode: element.examName,
						version: rs.exprVersion,
						// TODO: 변경해야함
						headerEtcCd02: element.areaCode === '01' ? '05' : '02',
						headerEtcCd01: element.passageClass,
						passageClass: element.passageClass,
						area: element.areaCode === '01' ? '문학' : '비문학',
						title: element.passageName,
						areaCode: element.areaCode,
						isDone: false,
						learningStatus: element.learningStatus,
						learningType: element.learningType,
						orgLearningType: element.orgLearningType,
						difficult:
							element.areaCode === '01'
								? JSON.parse(element.difficultyL)
								: JSON.parse(element.difficultyN),
						satOrder: element?.satOrder ? element?.satOrder : null,
						groupIndex: element?.groupIndex ? element?.groupIndex : null,
						level: element?.level,
						lesson: element?.lesson,
					});
				});
				areaCodeArr.value = tmpStudy;
				// console.log(tmpStudy);
				studyStore.currentInfo = null;
				studyStore.level = rs.level;
				studyStore.lesson = rs.lesson;
				studyStore.exprVersion = rs.exprVersion;
				studyStore.mapTree.exams = tmpMapTree;

				const fIndex = _.findIndex(rs.studyMain, function (o) {
					return o.examName === rs.currentStart.examName;
				});
				studyStore.process.examIdx = fIndex;
				if (rs.currentStart.learningStatus === 'W') {
					studyStore.process.studyTree = 5082;
					studyStore.process.learningHistorySeq = null;
				} else {
					studyStore.process.studyTree =
						rs.currentStart.currentCorner === 'earnest'
							? 5083
							: rs.currentStart.currentCorner === 'vocabulary'
							? 5084
							: 5082;
				}
				studyStore.process.problemOrd = 0;
				studyStore.process.exam = {
					// examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
					examCode: rs.currentStart.examName,
					version: rs.exprVersion,
					// TODO: 변경해야함
					headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
					headerEtcCd01: rs.currentStart.passageClass,
					passageClass: rs.currentStart.passageClass,
					area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
					title: rs.currentStart.passageName,
					areaCode: rs.currentStart.areaCode,
					isDone: false,
					learningHistorySeq: rs.currentStart.learningHistorySeq,
					learningType: rs.currentStart.learningType,
					orgLearningType: rs.currentStart.orgLearningType,
					learningStatus: rs.currentStart.learningStatus,
					difficult:
						rs.currentStart.areaCode === '01'
							? JSON.parse(rs.studyMain[fIndex]?.difficultyL)
							: JSON.parse(rs.studyMain[fIndex]?.difficultyN),
					satOrder: rs.currentStart?.satOrder
						? rs.currentStart?.satOrder
						: null,
					groupIndex: rs.currentStart?.groupIndex
						? rs.currentStart?.groupIndex
						: null,
					level: rs.currentStart?.level,
					lesson: rs.currentStart?.lesson,
					isReadPassage: rs.currentStart?.isReadPassage,
				};
				studyStore.setSuggestionIdx(rs?.studyMain[0]?.groupIndex?.toString());
			} else {
				studyStore.currentInfo = null;
				studyStore.level = rs.level;
				studyStore.lesson = rs.lesson;
				studyStore.exprVersion = rs.exprVersion;
				isAllCourseCompleted.value = rs.isAllCourseCompleted;
				areaCodeArr.value = [];
			}
			tempRs.value = '';
			// console.log("rs.studyMain : " + rs.studyMain);
			// console.log("rs.studyMain.length : " + rs.studyMain.length);
		}
		isLoading.value = false;
	}
};

const initData = async () => {
	await setMessage();
	await setUserMain();

	// getMainMessage((rs) => {
	//     if (rs?.length > 0) {
	//         message.value = { type: rs[0]?.typeStr, title: rs[0]?.title };
	//     }
	// });

	// getUserMain((rs) => {
	//     // console.log('--getUserMain-rs lesson-', rs.lesson);
	//     // console.log("rs : ");
	//     // console.log(rs);

	//     if (rs == 'noLevel') {
	//         tempRs.value = 'noLevel';
	//         // console.log("rs : " + rs + ", tempRs : " + tempRs.value);
	//     } else {
	//         let tmpMapTree = [];
	//         let tmpStudy = {};
	//         lev.value = rs.level;
	//         les.value = rs.lesson;
	//         if (rs.studyMain.length > 0) {
	//             rs.studyMain.forEach((element) => {
	//                 // let tmpItem = tmpStudy[element.areaCode + '_' + element.areaCode] === null ? [] : tmpStudy[element.areaCode + '_' + element.areaCode];
	//                 if (tmpStudy[element.learningType + '_' + element.areaCode]) {
	//                     if (tmpStudy[element.learningType + '_' + element.areaCode].length >= 2) {
	//                         if (tmpStudy[element.learningType + '_' + element.areaCode + 1]) tmpStudy[element.learningType + '_' + element.areaCode + 1].push(element);
	//                         else tmpStudy[element.learningType + '_' + element.areaCode + 1] = [element];
	//                     } else {
	//                         tmpStudy[element.learningType + '_' + element.areaCode].push(element);
	//                     }
	//                 } else {
	//                     tmpStudy[element.learningType + '_' + element.areaCode] = [element];
	//                 }
	//                 tmpMapTree.push({
	//                     // examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
	//                     examCode: element.examName,
	//                     version: rs.exprVersion,
	//                     // TODO: 변경해야함
	//                     headerEtcCd02: element.areaCode === '01' ? '05' : '02',
	//                     headerEtcCd01: element.passageClass,
	//                     passageClass: element.passageClass,
	//                     area: element.areaCode === '01' ? '문학' : '비문학',
	//                     title: element.passageName,
	//                     areaCode: element.areaCode,
	//                     isDone: false,
	//                     learningStatus: element.learningStatus,
	//                     learningType: element.learningType,
	//                     difficult: element.areaCode === '01' ? JSON.parse(element.difficultyL) : JSON.parse(element.difficultyN),
	//                     satOrder: element?.satOrder ? element?.satOrder : null,
	//                     groupIndex: element?.groupIndex ? element?.groupIndex : null,
	//                     level: element?.level,
	//                     lesson: element?.lesson,
	//                 });
	//             });
	//             areaCodeArr.value = tmpStudy;
	//             // console.log(tmpStudy);
	//             studyStore.currentInfo = null;
	//             studyStore.level = rs.level;
	//             studyStore.lesson = rs.lesson;
	//             studyStore.exprVersion = rs.exprVersion;
	//             studyStore.mapTree.exams = tmpMapTree;

	//             const fIndex = _.findIndex(rs.studyMain, function (o) {
	//                 return o.examName === rs.currentStart.examName;
	//             });
	//             studyStore.process.examIdx = fIndex;
	//             if (rs.currentStart.learningStatus === 'W') {
	//                 studyStore.process.studyTree = 5082;
	//                 studyStore.process.learningHistorySeq = null;
	//             } else {
	//                 studyStore.process.studyTree = rs.currentStart.currentCorner === 'earnest' ? 5083 : rs.currentStart.currentCorner === 'vocabulary' ? 5084 : 5082;
	//             }
	//             studyStore.process.problemOrd = 0;
	//             studyStore.process.exam = {
	//                 // examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
	//                 examCode: rs.currentStart.examName,
	//                 version: rs.exprVersion,
	//                 // TODO: 변경해야함
	//                 headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
	//                 headerEtcCd01: rs.currentStart.passageClass,
	//                 passageClass: rs.currentStart.passageClass,
	//                 area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
	//                 title: rs.currentStart.passageName,
	//                 areaCode: rs.currentStart.areaCode,
	//                 isDone: false,
	//                 learningType: rs.currentStart.learningType,
	//                 learningStatus: rs.currentStart.learningStatus,
	//                 difficult: rs.currentStart.areaCode === '01' ? JSON.parse(rs.studyMain[fIndex]?.difficultyL) : JSON.parse(rs.studyMain[fIndex]?.difficultyN),
	//                 satOrder: rs.currentStart?.satOrder ? rs.currentStart?.satOrder : null,
	//                 groupIndex: rs.currentStart?.groupIndex ? rs.currentStart?.groupIndex : null,
	//                 level: rs.currentStart?.level,
	//                 lesson: rs.currentStart?.lesson,
	//             };
	//         } else {
	//             studyStore.currentInfo = null;
	//             studyStore.level = rs.level;
	//             studyStore.lesson = rs.lesson;
	//             studyStore.exprVersion = rs.exprVersion;
	//             isAllCourseCompleted.value = rs.isAllCourseCompleted;
	//             areaCodeArr.value = [];
	//         }
	//         tempRs.value = '';
	//         // console.log("rs.studyMain : " + rs.studyMain);
	//         // console.log("rs.studyMain.length : " + rs.studyMain.length);
	//     }
	//     isLoading.value = false;

	//     // console.log("rs.studyMain : " + rs.studyMain);
	//     // console.log("rs.studyMain.length : " + rs.studyMain.length);
	// });
};
onMounted(() => {
	initData();
	let data = {
		menuName: route.path.split('/').join(''),
	};
	monitoringLog(data, res => {
		console.log('learninghome monitoringLog API response ===', res);
	});
});

const studyStart = () => {
	//2023-12-11 pby KRT-2152 -- 러닝홈에서 머물러 있는 상태에서 진도 변경 시 오류.
	setUserMain().then(() => {
		checkProgress(rs => {
			if (rs.modifyProgressFlag) {
				store.openAlertDialog({
					//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
					//message: '학습 진도가 ' + (rs.modifyProgressFlag ? '수정' : '리셋') + '되었습니다.\n 다시 학습을 진행해 주세요.',
					//2023-12-11 pby KRT-2153 -- 학습중 진도수정시 알럿 메세지 수정.
					message: '학습 진도가 변경되었습니다. ',
					buttonText: '확인',
					callback: () => {
						if (areaCodeArr.value.length === 0) {
							router.push('/eval-member?back=learninghome');
						} else if (
							studyStore.process.exam.learningType === 'SAT' ||
							studyStore.process.exam.learningType === 'SAT_RESET'
						) {
							router.push('/sat');
						} else
							router.push(
								studyStore.process.studyTree === 5083
									? '/authenticreading'
									: studyStore.process.studyTree === 5084
									? '/vocabularylearning'
									: 'corereading'
							);
					},
				});
			} else {
				if (areaCodeArr.value.length === 0) {
					router.push('/eval-member?back=learninghome');
				} else if (
					studyStore.process.exam.learningType === 'SAT' ||
					studyStore.process.exam.learningType === 'SAT_RESET'
				) {
					router.push('/sat');
				} else
					router.push(
						studyStore.process.studyTree === 5083
							? '/authenticreading'
							: studyStore.process.studyTree === 5084
							? '/vocabularylearning'
							: 'corereading'
					);
			}
		});
	});
};
</script>

<style scoped lang="scss">
h2 {
	font-size: 1.8vw;
	font-weight: 700;
	line-height: 2.6vw;
}

h3 {
	// margin-bottom: 2.67vmin;
	margin-bottom: 1.6vw;
	font-size: 1.8vw;
	font-weight: 700;
	line-height: 2.6vw;
}

p {
	margin: 0;
}

img {
	width: 100%;
}

::v-deep {
	.notice {
		.message {
			// margin-left: 2.42vmin;
			margin-left: 0.6vw;
			width: calc(89% - 0.6vw);
			font-size: 1.3vw;
			line-height: 2.1vw;
			cursor: pointer;

			&__title {
				display: block;
				width: 100%;
				@include text-ellipsis;
			}

			&__type {
				display: block;
				font-weight: 500;
				color: $color_gray_600;
			}
		}
	}

	.now-learning__header {
		.q-btn {
			padding: 0;
		}
		.q-hoverable:hover > .q-focus-helper,
		.q-hoverable:hover > .q-focus-helper:before {
			background: inherit;
		}
	}
	.button__content .button {
		max-height: 5.5vw;
		padding: 1.65vw 1.95vw;
		font-size: 1.5vw;
		line-height: 1.8vw;
	}
	.button__content .button__img {
		width: 2.1vw;
		height: 2.1vw;
	}
}

.main-container {
	display: flex;
	height: 100vh;
	color: $color_gray_900;
}

.greeting {
	padding-left: 40px;
	font-size: 2.4em;
	color: #222;
}

.dashboard {
	// min-width: 68.5%;
	min-width: 300px;
	max-width: 1116px;
	width: 56%;
	height: calc((var(--vh, 1vh) * 100));
	border-right: 4px solid $color_gray_200;

	&-info {
		position: relative;
		/* height: 26%;
    max-height: 310px; */

		.info__content {
			/* position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      padding: 0 3.83vmin;
      @include transform(translateY(-50%)); */

			width: 100%;
			// padding: 5.33vmin 3.83vmin 0;
			padding: 3.2vw 2.3vw 0;

			h2 {
				.q-icon {
					width: 2.5vw;
					height: 2.5vw;
				}
			}
		}

		.panel {
			// padding: 2.17vmin 5vmin 2.17vmin 4vmin;
			padding: 1.3vw 3vw 1.3vw 2.4vw;
		}

		.row {
			justify-content: space-between;
			align-items: center;
		}

		.col {
			&-9 {
				p {
					margin-top: 1vmin;
					font-size: 1.5vw;
					color: $color_gray_700;
					line-height: 1.9vw;
				}
			}

			&-3 {
				// width: 18%;
				// max-width: 158px;
				width: 7.9vw;
				height: 7.9vw;
			}
		}
	}

	&-mapicon {
		// margin-left: 20px;
		width: 86px;
		height: 62px;
		background-image: url('@/assets/images/main/Main_ic_knowledge map.png');
		background-repeat: no-repeat;
		background-position: center center;
	}

	&-note {
		// margin-left: 20px;
		width: 86px;
		height: 62px;
		background-image: url('@/assets/images/main/Main_ic_noticenote.png');
		background-repeat: no-repeat;
		background-position: center center;
	}

	&__content {
		position: relative;
		/* height: 75%;
    max-height: 890px; */
		// margin-top: 6.67vmin;
		margin-top: 4vw;
	}

	/*
    button {
        // margin-top: 3.5vmin;
        margin-top: 2.1vw;
        width: 100%;
        // height: 9vh;
        //height: 9vh;
        height: 9.17vmin;
        max-height: 110px;
        @include border-radius(0.8vw);
        font-size: 1.5vw;
        font-weight: 700;
        line-height: 1.8vw;

        .btn__txt {
            @include display-flex;
            align-items: center;

            span {
                font-weight: 700;
            }
        }

        .q-icon {
            width: 2.1vw;
            height: 2.1vw;
            font-size: 1.5vw;
        }
    }
    */
}

.panel {
	border: 1px solid $color_gray_400;
	@include border-radius(0.8vw);
	background: $color_gray_100;

	&__title {
		font-size: 2.3vw;
		font-weight: 700;
		line-height: 3.3vw;
	}

	&__txt {
		font-size: 1.3vw;
		color: $color_gray_700;
		text-align: center;
		line-height: 2.1vw;
	}
}

.learning {
	&-process {
		/* h3 {
            margin-top: 6.67vmin;
        } */
		/* position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    padding: 0 3.83vmin;
    @include transform(translateY(-50%)); */
		width: 100%;
		// padding: 0 3.83vmin;
		padding: 0 2.3vw;

		.panel {
			@include border-radius(0.8vw);

			&:first-of-type {
				border-top: 1px solid $color_gray_400;
			}

			&:nth-of-type(n + 2) {
				margin-top: 1.2vw;
			}
		}

		.literature {
			display: flex;
			flex-direction: row;
			width: 100%;
			//height: 50%;
			min-height: 120px;
			// padding: 6.31vmin 3.83vmin 5.83vmin 4.17vmin;
			padding: 3.5vw 2.3vw 3.5vw 2.5vw;
			// font-size: 1.3vw;
			// line-height: 2.1vw;

			&__title {
				font-weight: 700;
			}

			&__type {
				max-width: 180px;
				margin-left: 2.95vw;
				@include text-ellipsis;
			}

			&__content {
				width: 100%;

				.col {
					max-width: 423px;
				}
			}

			p {
				font-size: 1.3vw;
				line-height: 2.1vw;
			}

			.row {
				align-items: center;

				&:nth-of-type(n + 2) {
					margin-top: 0.8vw;
				}

				.col {
					@include display-flex;
					align-items: center;
				}
			}

			.chip,
			&__title {
				width: 12%;
				max-width: 106px;
				text-align: center;
			}

			.chip {
				&-outline {
					margin-left: 0.4vw;
				}

				.q-chip {
					color: $color_gray_800;
				}
			}

			.q-chip {
				margin: 0;
				@include border-radius(1.1vw);
				font-size: 1vw;
				font-weight: 500;
				line-height: 1.3vw;
			}

			.level {
				display: flex;
				align-items: center;
				width: 9%;
				max-width: 77px;
				margin-left: 3vw;
				color: $color_gray_600;
				white-space: nowrap;
			}

			.pass-name {
				margin-left: 0.9vw;
				//width: 100%;
				max-width: 327px;
				@include text-ellipsis;
			}
		}
	}

	&__img {
		/* width: 56%;
        max-width: 280px;
        max-height: 280px; */
		width: 14vw;
		height: 14vw;
		margin: 0 auto;
	}
}

.sat,
.diagnosis {
	position: relative;
	/* height: 57%;
  min-height: 42vmin; */

	&__img {
		// width: 18%;
		// max-width: 154px;
		// max-height: 154px;
		width: 7.7vw;
		height: 7.7vw;
	}

	/* .panel {
    &__inner {
      position: absolute;
      bottom: 3.67vmin;
      left: 0;
      width: 100%;
      padding: 0 3.67vmin;
    }
  } */
}

.sat {
	&__content {
		@include display-flex;
		justify-content: center;
		align-items: center;
	}

	/* &__txt {
        margin-left: 1vmin;
    } */

	.panel {
		&__inner {
			width: 100%;
			// padding: 12.33vmin 3.67vmin 3.67vmin;
			padding: 7.4vw 2.2vw 2.2vw;
		}
	}

	.level {
		font-size: 1.5vw;
		font-weight: 500;
		color: $color_gray_600;
		line-height: 1.9vw;

		span {
			&:nth-of-type(n + 2) {
				margin-left: 0.8vw;
			}
		}
	}

	.panel__title {
		margin-top: 0.3vw;
	}
	.panel__txt {
		margin-top: 5.8vw;
	}
}

.diagnosis {
	&__content {
		@include display-flex;
		justify-content: center;
		align-items: center;
	}

	&__kread {
		// margin-left: 3.06vmin;
		margin-left: 1.85vw;
		width: 17%;
		max-width: 157px;
		max-height: 42px;
	}

	.panel {
		&__inner {
			width: 100%;
			// padding: 12.92vmin 3.67vmin 3.67vmin;
			padding: 7.75vw 2.2vw 2.2vw;
		}

		&__title {
			// margin-left: 1.33vmin;
			margin-left: 0.8vw;
		}

		&__txt {
			// margin-top: 5.58vmin;
			margin-top: 3.35vw;
		}
	}
}

.course_complete {
	&__content {
		@include display-flex;
		justify-content: center;
		align-items: center;
	}

	.panel {
		&__inner {
			width: 100%;
			// padding: 12.92vmin 3.67vmin 3.67vmin;
			// padding: 3.67vmin 3.67vmin;
		}

		/*
    &__title {
      margin-left: 1.33vmin;
    }
    */
		&__txt {
			// margin-top: 5.58vmin;
			margin: 17.5vmin 0;
		}
	}
}

.notice {
	width: 100%;
	// min-height: 11.08vmin;
	// padding: 2.17vmin 2vmin 2.17vmin 1.33vmin;
	padding: 1.15vw 0.7vw 1.15vw 1vw;

	&__content {
		@include display-flex;
		align-items: center;
		min-height: 4vw;
	}

	.q-icon {
		display: block;
		// width: 18%;
		// max-width: 80px;
		width: 4vw;
		height: 4vw;
		line-height: 0;
	}

	/* .message {
    margin-left: 2.42vmin;
    width: calc(89% - 2.42vmin);
    font-size: 1.3vw;
    line-height: 2.1vw;

    &__title {
      display: block;
      width: 100%;
      @include text-ellipsis;
    }

    &__type {
      display: block;
      font-weight: 500;
      color: $color_gray_600;
    }
  } */
}

.infobaord {
	position: relative;
	width: 34%;
	height: calc((var(--vh, 1vh) * 100));

	&__content {
		position: relative;
		/* height: 74%;
    max-height: 883px; */
		// margin-top: 6.08vmin;
		margin-top: 4vw;
	}
}

.today-notification {
	position: relative;
	/* height: 26%;
  max-height: 317px; */
}

.notification__content {
	/* position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  padding: 0 3.83vmin;
  @include transform(translateY(-50%)); */

	width: 100%;
	// margin-top: 5.33vmin;
	// padding: 0 3.83vmin;
	padding: 3.2vw 2.3vw 0;
}

.now-learning {
	/* position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  padding: 0 3.83vmin;
  @include transform(translateY(-50%));*/

	width: 100%;
	padding: 0 2.3vw;

	&__header {
		@include display-flex;
		justify-content: space-between;
		align-items: center;
		// margin-bottom: 2.67vmin;
		margin-bottom: 1.6vw;
	}

	&__content {
		position: relative;
		/* height: 75%;
    min-height: 54.67vmin; */
		// min-height: 54.67vmin;
		min-height: 32.3vw;
		max-height: 656px;
	}

	h3 {
		margin-bottom: 0;
	}

	.panel {
		&__inner {
			position: relative;
			// position: absolute;
			// top: 50%;
			// top: 2.2vw;
			// left: 0;
			width: 100%;
			// padding: 0 3.33vmin 0 3.42vmin;
			// padding: 0 2vw;
			// @include transform(translateY(-50%));
		}
	}

	.level,
	.lesson {
		p {
			margin-bottom: 1.5vw;
			font-size: 1.5vw;
			font-weight: 700;
			color: $color_gray_800;
			line-height: 1.9vw;
		}
	}

	.lesson {
		margin-top: 5.9vw;

		/* p {
            margin-bottom: 2.4vmin;
        } */
	}

	.more {
		font-size: 1.2vw;
		font-weight: 700;
		color: $color_gray_600;
		line-height: 1.6vw;

		&__btn {
			@include display-flex;
			width: 2.6vw;
			height: 2.6vw;
		}
	}
}

// 5월 31일용
.learning-beginning2 {
	position: absolute;
	top: 0vw;
	left: 0;
	width: 100%;
	padding: 0 2vw;
}

.learning-beginning {
	position: absolute;
	top: 2.2vw;
	left: 0;
	width: 100%;
	padding: 0 2vw;
}
.beginning__title {
	font-size: 1.3vw;
	font-weight: 500;
	color: $color_gray_600;
	text-align: center;
	line-height: 2.1vw;
}
.during-learning {
	position: absolute;
	top: 3.5vw;
	left: 0;
	width: 100%;
	padding: 0 2.1vw;
}

.roundedBtnOutPrimary {
	margin: 0;
	padding: 1.17vmin 3.33vmin;
	border-radius: 1.3vmin;
	/* border: 1px solid black;  */
	background-color: #8e43f0;
}
.button__content {
	margin-top: 2.1vw;
}
@include pc_full {
	h3,
	.now-learning__header {
		margin-bottom: 1.4vw;
	}
	.dashboard__content,
	.infobaord__content {
		margin-top: 2.5vw;
	}

	.diagnosis .panel__inner,
	.sat .panel__inner {
		padding: 4.4vw 2.2vw 2.2vw;
	}

	.now-learning__content {
		min-height: 29vw;
	}

	.learning-process .literature {
		padding: 2.5vw 2.3vw 2.5vw 2.5vw;
	}
	.now-learning .lesson {
		margin-top: 4vw;
	}
	.sat .panel__txt {
		margin-top: 4.8vw;
	}
	.button__content {
		margin-top: 1.9vw;
	}
	.now-learning .level p,
	.now-learning .lesson p {
		margin-bottom: 1.3vw;
	}
}
@media screen and (max-width: 1600px) {
	.learning-process .literature {
		min-height: inherit;
		padding: 2.2vw 2.3vw 2.2vw 2.5vw;
	}
	.sat .panel__txt {
		margin-top: 3.9vw;
	}
	.diagnosis .panel__txt {
		margin-top: 1.75vw;
	}
	.now-learning__content {
		min-height: 28vw;
	}
	.now-learning .level p,
	.now-learning .lesson p {
		margin-bottom: 1.1vw;
	}

	::v-deep {
		.now-learning {
			.q-btn {
				min-height: inherit;
			}
		}
	}
}
@include tablet_l {
	.main-container {
		min-width: 1024px;
		overflow-x: auto;
	}
	.dashboard__content,
	.infobaord__content {
		margin-top: 4vw;
	}

	.learning-process .literature {
		padding: 3.5vw 2.3vw 3.5vw 2.5vw;
	}
	.button__content {
		margin-top: 2.1vw;
	}
	.now-learning__content {
		min-height: 33.7vw;
	}
	.now-learning .lesson {
		margin-top: 5.9vw;
	}
	.now-learning .level p,
	.now-learning .lesson p {
		margin-bottom: 1.5vw;
	}
	.diagnosis .panel__inner,
	.sat .panel__inner {
		padding: 8.2vw 2.2vw 2.2vw;
	}
	.diagnosis .panel__txt {
		margin-top: 3.35vw;
	}

	.diagnosis1 .panel__txt {
		margin-top: 5.5vw;
	}
	.sat .panel__txt {
		margin-top: 5.5vw;
	}
}
</style>
